import * as React from "react";
import { page } from "../../components/Auth/Page";

export const OrgCheckoutPage = page(React.lazy(() => import("./OrgCheckout")));
